var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.24048V7.24048C14 7.5057 14.1054 7.76005 14.2929 7.94759C14.4804 8.13512 14.7348 8.24048 15 8.24048H19",
    stroke: "#7D7D7D",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.2405H7C6.46957 21.2405 5.96086 21.0298 5.58579 20.6547C5.21071 20.2796 5 19.7709 5 19.2405V5.24048C5 4.71005 5.21071 4.20134 5.58579 3.82626C5.96086 3.45119 6.46957 3.24048 7 3.24048H14L19 8.24048V19.2405C19 19.7709 18.7893 20.2796 18.4142 20.6547C18.0391 21.0298 17.5304 21.2405 17 21.2405Z",
    stroke: "#7D7D7D",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.e26d50f0c2fca415976f4141262b5948.svg";
export { ForwardRef as ReactComponent };